/**
 * Trace ID Generation
 * 
 * Generates and manages trace IDs for end-to-end operation tracking.
 */

/**
 * Start a new trace
 */
export function start(operation?: string): string {
  const traceId = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  activeTraces.set(traceId, {
    startTime: Date.now(),
    operation: operation || 'unknown',
  });
  return traceId;
}

/**
 * End a trace
 */
export function end(traceId: string): void {
  activeTraces.delete(traceId);
}


/**
 * Trace metadata
 */
interface TraceMetadata {
  startTime: number;
  operation: string;
}

/**
 * Active traces
 */
const activeTraces = new Map<string, TraceMetadata>();

/**
 * Get trace duration
 */
function getTraceDuration(traceId: string): number | null {
  const trace = activeTraces.get(traceId);
  if (trace) {
    return Date.now() - trace.startTime;
  }
  return null;
}

